import type {ReactElement} from 'react';
import React from 'react';
import type {LayoutOptions} from '@Components/contextual-menu/components/contextual-menu-layout-button';
import {ContextualMenuLayoutButton} from '@Components/contextual-menu/components/contextual-menu-layout-button';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';

interface MenuLayoutOptionProps {
  onClickLayout(): void;
  layoutFor: LayoutOptions;
}

export function LayoutOption({...props}: MenuLayoutOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const layoutStyle = useGetKeyFromTableItem('layoutStyle');

  if (!activeItem || (activeItem && !('layoutStyle' in activeItem)) || layoutStyle === undefined) {
    throw new Error(`Item doesn't have layoutStyle property`);
  }

  return (
    <ContextualMenuLayoutButton
      id="menu-layout-option"
      label={window.i18next.t('pmwjs_layout')}
      layoutName={layoutStyle}
      layoutFor={props.layoutFor}
      onClickButton={(): void => {
        props.onClickLayout();
      }}
    />
  );
}
